/* eslint-disable react/no-danger */
import React, { memo } from "react";
import useOrderWsMessageData from "../../../hooks/inbox/data/useOrderWsMessageData";
import useOrderWsMessageActions from "../../../hooks/inbox/actions/useOrderWsMessageActions";
import ImageMC from "../../../components/ImageMC";

/**
 * RepliedOrderWsMessageMC - Componente para mostrar un mensaje de pedido WhatsApp en el Inbox.
 */
const RepliedOrderWsMessageMC = memo(({ conversation, message }) => {
  const { data, messageText } = useOrderWsMessageData({ platform: conversation.platform, message });
  const { handleToggleModal } = useOrderWsMessageActions({ message });
  return (
    <>
      <div
        className="tw-p-2 tw-text-pre-line tw-text-left tw-text-xs"
        dangerouslySetInnerHTML={{ __html: messageText }}
      />
      <ImageMC
        platform={conversation.platform}
        data={data}
        onClick={handleToggleModal}
        className="tw-block tw-w-full tw-h-full tw-object-cover tw-rounded-[9px] tw-bg-white tw-cursor-pointer !tw-max-w-none !tw-max-h-none"
      />
    </>
  );
});

RepliedOrderWsMessageMC.displayName = "RepliedOrderWsMessageMC";

export default RepliedOrderWsMessageMC;